import { Avatar, Button, Col, DatePicker, Divider, Flex, Form, Input, InputNumber, notification, Row, Select, Switch, Table, Tag, Tooltip } from 'antd';
import { CheckOutlined, CheckSquareFilled, MenuUnfoldOutlined, UploadOutlined, UserOutlined, SmileOutlined, VideoCameraOutlined, HomeOutlined, AppstoreOutlined, MailOutlined, SettingOutlined, BellOutlined, HeartOutlined, SearchOutlined, DeleteOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import MasterDataAPI from '../../../../restAPI/MasterDataAPI';
import { useSelector } from 'react-redux';
import CommitteeAPI from '../../../../restAPI/CommitteeAPI';

const CommitteeInfo = forwardRef((props, ref) => {
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const { committee } = useSelector(state => state.meeting);
    const [form] = Form.useForm();

    const [committeeType, setCommitteeType] = useState(null);
    const [committeeName, setCommitteeName] = useState(null);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [committeeData, setCommitteeData] = useState([]);
    const [committeeNameList, setCommitteeNameList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [memberListByBranch, setMemberListByBranch] = useState([])
    const [fullDataMemberListByBranch, setFullDataMemberListByBranch] = useState([])
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [companyUsersList, setCompanyUsersList] = useState([]);

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    useEffect(() => { //sample meeting for participant list check
        if (!committee) return;

        const { participants } = committee;

        const fromValues = {
            committeeType: participants.committeeType || '',
            committeeName: participants.committeeId || '',
        };
        form.setFieldsValue(fromValues);
        setCommitteeType(participants.committeeType || null);
        setCommitteeName(participants.committeeId || null);

        const members = participants.members || [];

        const mappedMembers = members.map(member => ({
            id: member.userDetailsId,
            key: member.userDetailsId,
            userDetailsId: member.userDetailsId,
            name: member.name || 'No data',
            branch: member.branch || 'No data',
            designation: member.designation || 'No data',
            attendance: member.attendance || 'optional',
        }));
        setSelectedMembers(mappedMembers);
        props.setCommitteeMembersList(mappedMembers);

    }, [props.isPrevClickedToCommittee, committee, form]);

    useImperativeHandle(ref, () => ({
        validateAndRetrieveData: async () => {
            try {
                const values = await form.validateFields();
                return values;
            } catch (error) {
                // console.log("___throw error :", error)
                throw error;
            }
        },
    }));

    const getuserList = async () => {
        const res = await MasterDataAPI.getUsersDataByCompanyId(companyId, token);
        if (res) {
            const newMemberDataList = res?.data ? res?.data.filter(user => user.status).map(singleUser => {
                return {
                    id: singleUser._id,
                    name: singleUser.name,
                    designation: singleUser.designation,
                    email: singleUser.email,
                    mobileNumber: singleUser.personalNumber,
                    companyAddress: singleUser.address,
                    branchId: singleUser.branchId,
                    roleList: singleUser.roleId
                };
            }) : [];

            setCompanyUsersList(newMemberDataList);
        }
    }

    const getCommitteeTypes = async () => {
        await MasterDataAPI.getCommitteeDataByCompanyId(companyId, token)
            .then((res) => {
                const activeCommittee = res?.data ? res?.data.filter(committee => committee.status).map(committee => {
                    return { label: committee.name, value: committee._id };
                }) : [];
                setCommitteeData(activeCommittee);
            })
            .catch((err) => {
                console.log("Error :", err.message);
            })
    }
    const getBranchList = async () => {
        await MasterDataAPI.getBranchDataByCompanyId(companyId, token)
            .then((res) => {
                if (res) {
                    const activeBranches = res?.data ? res?.data.filter(branch => branch.status).map(singleBranch => {
                        return { label: singleBranch.name, value: singleBranch._id };
                    }) : [];
                    setBranchList(activeBranches);
                }
            })
            .catch((err) => {
                console.log("Error :", err.message);
            })
    }

    const getCommitteeListByCommitteeTypeId = async () => {
        try {
            const res = await CommitteeAPI.getCommitteesByCommitteeType(committeeType, companyId, token);
            if (res) {
                const activeCommitteeNamesList = res.data ? res.data.data.filter(committee => committee.status).map(committee => {
                    return { label: committee.name, value: committee._id };
                }) : [];
                setCommitteeNameList(activeCommitteeNamesList);
            }
        } catch (error) {
            console.log("error getCommitteeListByCommitteeTypeId :", error);
        }
    }
    // const getCommitteeListByCommitteeTypeId = async () => {
    //     try {
    //         const res = await CommitteeAPI.getCommitteesByCommitteeTypeIdWithMeetingPermission(committeeType, companyId, token);
    //         if (res) {
    //             const activeCommitteeNamesList = res.data ? res.data.data.filter(committee => committee.status).map(committee => {
    //                 return { label: committee.name, value: committee._id };
    //             }) : [];
    //             setCommitteeNameList(activeCommitteeNamesList);
    //         }
    //     } catch (error) {
    //         console.log("error getCommitteeListByCommitteeTypeId :", error);
    //     }
    // }

    const getUserListByBranchId = async () => {
        try {
            const res = await MasterDataAPI.getUserListByBranchId(selectedBranchId, companyId, token);
            if (res) {
                const tempUserList = res.data.filter(user => user.status).map(singleUser => {
                    return { label: singleUser.name, value: singleUser._id };
                })
                // console.log("___tempUserList :", tempUserList)
                setMemberListByBranch(tempUserList);
                setFullDataMemberListByBranch(res.data);
            }
        } catch (error) {
            console.log("Error in getUserListByBranchId :", error)
        }
    }

    const getCommitteeDataByCommitteeId = async () => {
        try {
            const res = await MasterDataAPI.getCommitteeDataByCommitteeId(committeeName, companyId, token);
            if (res) {
                const {secretaryId, assistantSecretaryId} = res.data;
                const equalUsers = companyUsersList.filter(user => res.data?.members.includes(user.id));

                const transformUsers = equalUsers.map(user => ({
                    id: user.id,
                    name: user.name,
                    branch: user.branchId ? user.branchId.name : 'No data',
                    designation: user.designation || 'No data',
                    response: 'optional',
                    isDeletable: !(user.id === secretaryId || user.id === assistantSecretaryId)
                }));

                const transformUsersForProps = equalUsers.map(user => ({
                    userDetailsId: user.id,
                    // committeeId: committeeName,
                    name: user.name,
                    branch: user.branchId ? user.branchId.name : 'No data',
                    designation: user.designation || 'No data',
                    attendance: 'optional'
                }));

                setSelectedMembers(transformUsers);
                // setSelectedMembers(prev => {
                //     if (prev.length > 0) {
                //         return [...prev, ...transformUsers];
                //     } else {
                //         return transformUsers;
                //     }
                // });
                props.setCommitteeMembersList(transformUsersForProps);
            }
        } catch (error) {
            console.log("error in getCommitteeDataByCommitteeId : ", error)
        }
    }

    useEffect(() => {
        getuserList();
        getCommitteeTypes();
        getBranchList();
    }, [])

    useEffect(() => {
        if (committeeType) {
            getCommitteeListByCommitteeTypeId();
        }
        if (committeeType && !props.isPrevClickedToCommittee && !committee) {
            form.setFieldsValue({ committeeName: null });
            setCommitteeNameList([]);
        }
    }, [committeeType]);

    useEffect(() => {
        if (selectedBranchId) {
            setSelectedMemberId(null);
            getUserListByBranchId();
        }
    }, [selectedBranchId])

    useEffect(() => {
        if (committeeName && !props.isPrevClickedToCommittee && !committee) {
            getCommitteeDataByCommitteeId()
        }
    }, [committeeName])

    const handleAddClick = (e) => {
        // Validation for branch and member selection
        const validateField = (fieldName, errorMessage) => {
            form.setFields([{ name: fieldName, errors: [errorMessage] }]);
        };

        if (!selectedBranchId) validateField('branchName', 'Please select a branch name.');
        if (!selectedMemberId) validateField('memberName', 'Please select a member.');

        const selectedMemberDetails = fullDataMemberListByBranch.find(member => member._id === selectedMemberId);

        if (selectedMemberDetails) {
            const selectedBranchDetails = branchList?.find(branch => branch.value === selectedMemberDetails.branchId);

            const isMemberAlreadyAdded = (membersArray) =>
                membersArray.some(member => member.id === selectedMemberDetails._id);

            // Check if the member is already in selectedMembers or props.committeeMembersList
            if (isMemberAlreadyAdded(selectedMembers) || isMemberAlreadyAdded(props.committeeMembersList)) {
                openNotificationWithIcon('error', 'Duplicate member', 'Member already exists in the list.', 'bottomLeft');
                return;  // Exit early if duplicate
            }

            const newMember = {
                id: selectedMemberDetails._id,
                name: selectedMemberDetails.name,
                branch: selectedBranchDetails?.label || 'No data',
                designation: selectedMemberDetails.designation || 'No data',
                response: "default"
            };

            // Update the selectedMembers state
            setSelectedMembers(prev => [...prev, newMember]);

            // Update the committeeMembersList in the parent component
            props.setCommitteeMembersList(prev => [
                ...prev,
                {
                    ...newMember,
                    userDetailsId: selectedMemberDetails._id,
                    attendance: 'optional'
                }
            ]);
            form.resetFields(['branchName', 'memberName']);
            setSelectedMemberId(null);
            setSelectedBranchId(null)
            openNotificationWithIcon('success', 'Member added', 'Member added successfully.', 'bottomLeft');
        }
    };

    const handleMakeMandatery = (record) => {
        if (props.committeeMembersList) {
            const updatedList = props.committeeMembersList.map(member => {
                if (member.userDetailsId === record.id) {
                    return { ...member, attendance: 'mandatory' };
                }
                return member;
            });

            props.setCommitteeMembersList(updatedList);
        }
    }

    const handleRemoveMember = (record) => {
        const filteredArray = selectedMembers.filter(item => item.id !== record.id);
        const propsFilteredArray = props.committeeMembersList.filter(item => item.userDetailsId !== record.id);
        setSelectedMembers(filteredArray);
        props.setCommitteeMembersList(propsFilteredArray);
    }


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Branch',
            dataIndex: 'branch',
            key: 'branch',
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
        },
        {
            title: 'Response',
            dataIndex: 'response',
            key: 'response',
            align: 'center',
            render: (_, record) => (
                record.rsvp === 'yes' ?
                    (<>
                        <Tag color='green' style={{ width: 90, textAlign: 'center' }}>Attend</Tag> <br />
                    </>) :
                    record.rsvp === 'no' ?
                        (<Tag color='blue' style={{ width: 90, textAlign: 'center' }}>Not-Attend</Tag>) :
                        record.rsvp === 'May-Be' ?
                            (<Tag color='gold' style={{ width: 90, textAlign: 'center' }}>May-Be</Tag>) : <Tag color='red' style={{ width: 90, textAlign: 'center' }}>RSVP</Tag>
            )
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        <Tooltip title="Make Mandatery">
                            <Button icon={<CheckOutlined />} size='small' onClick={() => handleMakeMandatery(record)} />
                        </Tooltip>
                        {/* <Button type="primary" icon={<EditOutlined />} size='small' /> */}
                        <Button danger type="primary" icon={<DeleteOutlined />} size='small' onClick={() => handleRemoveMember(record)} disabled={record.isDeletable === false} />
                    </Flex>
                </Flex>
            ),
        }
    ];

    return (
        <Form layout="vertical" form={form}>
            {contextHolder}
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item label="Committee Type" name="committeeType" rules={[{ required: true, message: "Please select the committee type." }]}>
                        <Select
                            options={committeeData}
                            placeholder="Select committee type"
                            onChange={(value) => setCommitteeType(value)}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Committee" name="committeeName" rules={[{ required: true, message: "Please select the committee." }]}>
                        <Select
                            options={committeeNameList}
                            placeholder="Select committee"
                            onChange={(value) => setCommitteeName(value)}
                            value={committeeName}
                            disabled={!committeeType && !committeeName}
                        />
                    </Form.Item>
                </Col>
                <Divider>Add Other Members</Divider>
                <Col span={8}>
                    <Form.Item label="Branch" name="branchName" >
                        <Select
                            options={branchList}
                            placeholder="Please select a branch"
                            allowClear={true}
                            onChange={(value) => {
                                setSelectedBranchId(value)
                                form.setFields([
                                    {
                                        name: 'branchName',
                                        errors: [] // Clear the error message when starts typing
                                    }
                                ])
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item label='Member Name' name="memberName" >
                        <Flex justify='space-between' align='center' gap={24}>
                            <Select
                                showSearch
                                options={memberListByBranch}
                                allowClear={true}
                                onChange={(value) => {
                                    setSelectedMemberId(value)
                                    form.setFields([
                                        {
                                            name: 'memberName',
                                            errors: [] // Clear the error message when starts typing
                                        }
                                    ])
                                }}
                                value={selectedMemberId}
                            />
                            <Button onClick={(e) => handleAddClick(e)}> Add </Button>
                        </Flex>
                    </Form.Item>
                </Col>
                <div style={{ width: '100%' }}>
                    <Table
                        dataSource={selectedMembers}
                        columns={columns}
                        title={() => 'Selected Members'}
                        expandable={{
                            expandedRowRender: (record) => (
                                record.description !== "" ?
                                    <p
                                        style={{
                                            margin: 0,
                                        }}
                                    >
                                        {record.alternate !== " " ? <Tag color='gold'>{record.alternate}</Tag> : ""}

                                        {record.description}
                                    </p> : ""
                            ),
                            rowExpandable: (record) => record.rsvp !== 'yes',
                        }}
                    />
                </div>
            </Row>
        </Form>
    )
});

export default CommitteeInfo;